/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VCalendar from "v-calendar";
import Datetime from "vue-datetime";
import VueTheMask from "vue-the-mask";
import HighchartsVue from 'highcharts-vue'
import "vue-datetime/dist/vue-datetime.css";
import {FileManagerPlugin} from "@syncfusion/ej2-vue-filemanager";
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.plugins.register(ChartDataLabels);

import axios from 'axios';

if(window.Laravel != undefined) {
    axios.interceptors.request.use((config) => {
        // Get user_id and team_id from Laravel's global object

        const userId = window.Laravel.user_id || null;
        const teamId = window.Laravel.team_id || null;

        // Add the IDs to the headers
        config.headers['X-User-ID'] = userId;
        config.headers['X-Tenant-ID'] = teamId;

        return config;
    }, (error) => {
        return Promise.reject(error);
    });
}

Vue.prototype.$Chart = Chart; // Optionally attach Chart to Vue prototype
Vue.use(BootstrapVue);
Vue.use(VCalendar);
Vue.use(Datetime);
Vue.use(VueTheMask);
Vue.use(HighchartsVue);
Vue.use(FileManagerPlugin);


import algoliasearch from "algoliasearch/lite";
window.algoliasearch = algoliasearch;
import InstantSearch from "vue-instantsearch";
Vue.use(InstantSearch);
Vue.use(FileManagerPlugin);
Vue.prototype.syncfusionKanbanLicenseKey = 'ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5WdEZjXXpZcHBRQGJdWkd1';
require("spark-bootstrap");
require("./components/bootstrap");


const files = require.context("./", true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
            .split("/")
            .pop()
            .split(".")[0],
        files(key).default
    )
);

Vue.prototype.flash = (text, type) => {
    Bus.$emit("flash-message", { text, type: type || "success" });
};

Vue.prototype.getSafe = (fn) => {
    try {
        return fn();
    } catch (error) {
        // console.log('Warning: ' + error);
        return "";
    }
};

const app = new Vue({
    mixins: [require("spark")]
});
